import { css } from '@emotion/css';

const SETTINGS_WIDTH = 34;

export const settingsContainerStyles = css`
  width: ${SETTINGS_WIDTH}rem;
`;

export const formPicklistStyles = css`
  .MuiOutlinedInput-input {
    min-width: unset;
    flex: 0;
  }
`;
